import classNames from 'classnames';
import { useTranslations } from 'next-intl';

// Small gradient "Soon" pill — matches the "Coming soon" badge used in the
// visitor nav menu (see VisitorHeader/NavMenu) for not-yet-launched items,
// and reuses the same `nav.comingSoon` label so it stays translated.
export const ComingSoonBadge = ({ className }: { className?: string }) => {
  const t = useTranslations();
  return (
    <span className={classNames(styles.badge, className)}>
      {t('nav.comingSoon')}
    </span>
  );
};

const styles = {
  badge:
    'inline-flex translate-y-[-1px] items-center whitespace-nowrap rounded-full bg-[linear-gradient(90deg,#2757BA,#7B5CE6)] px-2 py-[3px] align-middle text-[9px] font-bold uppercase leading-none tracking-[0.06em] text-white shadow-[0_2px_6px_rgba(39,87,186,0.35)]',
};
